var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-gene-set-inspector-stack" },
    [
      _vm.hasHeader
        ? _c("section", { staticClass: "wkb-inspector-panel-block" }, [
            _c("h3", { staticClass: "wkb-inspector-node-title" }, [
              _vm._v(_vm._s(_vm.node.label || _vm.node.id)),
            ]),
            _vm.displaySubtitle
              ? _c("p", { staticClass: "wkb-inspector-node-subtitle" }, [
                  _vm._v(" " + _vm._s(_vm.displaySubtitle) + " "),
                ])
              : _vm._e(),
            _c("div", { staticClass: "wkb-inspector-connected" }, [
              _vm._m(0),
              _c("div", { staticClass: "wkb-inspector-connected-group" }, [
                _c("p", { staticClass: "wkb-inspector-connected-line" }, [
                  _vm._v("with Active edges:"),
                ]),
                _vm.activeConnectedNeighbors.length
                  ? _c(
                      "ul",
                      { staticClass: "wkb-inspector-connected-bubbles" },
                      _vm._l(_vm.activeConnectedNeighbors, function (neighbor) {
                        return _c("li", { key: `active-${neighbor.id}` }, [
                          _c(
                            "div",
                            {
                              staticClass: "wkb-inspector-connected-bubble",
                              class: `wkb-inspector-connected-bubble--${neighbor.linkKind}`,
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "wkb-inspector-connected-bubble-label",
                                },
                                [_vm._v(_vm._s(neighbor.label))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "wkb-inspector-connected-bubble-actions",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-connected-bubble-action",
                                      class: {
                                        "is-dimmed":
                                          !_vm.canInspectEdge(neighbor),
                                      },
                                      attrs: {
                                        type: "button",
                                        disabled: !neighbor.edgeRef,
                                        title: "Inspect connecting edge",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onInspectConnectingEdge(
                                            neighbor
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Edge ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "wkb-inspector-connected-bubble-action",
                                      attrs: {
                                        type: "button",
                                        disabled: !neighbor.nodeInspectable,
                                        title: "Inspect node",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onInspectConnectedNode(
                                            neighbor
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Node ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      }),
                      0
                    )
                  : _c("p", { staticClass: "wkb-inspector-connected-empty" }, [
                      _vm._v("None"),
                    ]),
              ]),
              _c("div", { staticClass: "wkb-inspector-connected-group" }, [
                _c("p", { staticClass: "wkb-inspector-connected-line" }, [
                  _vm._v("with Contextual edges:"),
                ]),
                _vm.contextualConnectedNeighbors.length
                  ? _c(
                      "ul",
                      { staticClass: "wkb-inspector-connected-bubbles" },
                      _vm._l(
                        _vm.contextualConnectedNeighbors,
                        function (neighbor) {
                          return _c(
                            "li",
                            { key: `contextual-${neighbor.id}` },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "wkb-inspector-connected-bubble",
                                  class: `wkb-inspector-connected-bubble--${neighbor.linkKind}`,
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "wkb-inspector-connected-bubble-label",
                                    },
                                    [_vm._v(_vm._s(neighbor.label))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "wkb-inspector-connected-bubble-actions",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "wkb-inspector-connected-bubble-action",
                                          class: {
                                            "is-dimmed":
                                              !_vm.canInspectEdge(neighbor),
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled: !neighbor.edgeRef,
                                            title: "Inspect connecting edge",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onInspectConnectingEdge(
                                                neighbor
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Edge ")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "wkb-inspector-connected-bubble-action",
                                          attrs: {
                                            type: "button",
                                            disabled: !neighbor.nodeInspectable,
                                            title: "Inspect node",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onInspectConnectedNode(
                                                neighbor
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Node ")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _c("p", { staticClass: "wkb-inspector-connected-empty" }, [
                      _vm._v("None"),
                    ]),
              ]),
              _c("p", { staticClass: "wkb-inspector-connected-footnote" }, [
                _vm._v(
                  " Edge inspect is available for gene–trait links; other edge types open a summary only. "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._l(_vm.geneSetProvenanceIds, function (geneSetId, index) {
        return _c("WorkspaceGeneSetProvenancePanel", {
          key: `${_vm.node.id}-provenance-${index}-${geneSetId}`,
          attrs: { "gene-set-id": geneSetId, "gene-set-node": _vm.node },
        })
      }),
      !_vm.geneSetProvenanceIds.length
        ? _c("p", { staticClass: "wkb-gene-set-provenance-unavailable" }, [
            _vm._v(
              " Provenance detail is available when this gene set has a Translator catalog "
            ),
            _c("code", [_vm._v("standard_name")]),
            _vm._v(
              " (for example GTEx incubator gene sets from semantic search). "
            ),
          ])
        : _vm._e(),
      _c("WorkspaceNodeConnectionTabs", {
        attrs: {
          node: _vm.node,
          "key-node-items": _vm.keyNodeItems,
          "session-context": _vm.sessionContext,
          "graph-nodes": _vm.graphNodes,
          "connection-cache": _vm.connectionCache,
          "api-client": _vm.apiClient,
          "graph-busy": _vm.graphBusy,
        },
        on: {
          "cache-connections": function ($event) {
            return _vm.$emit("cache-connections", $event)
          },
          "add-node": function ($event) {
            return _vm.$emit("add-node", $event)
          },
          "remove-node": function ($event) {
            return _vm.$emit("remove-node", $event)
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-inspector-connected-head" }, [
      _c("span", { staticClass: "wkb-inspector-connected-title" }, [
        _vm._v("Connected:"),
      ]),
      _c(
        "div",
        {
          staticClass: "wkb-inspector-connected-legend",
          attrs: { "aria-hidden": "true" },
        },
        [
          _c("span", { staticClass: "wkb-inspector-connected-legend-item" }, [
            _c("span", {
              staticClass:
                "wkb-inspector-connected-swatch wkb-inspector-connected-swatch--direct",
            }),
            _vm._v(" Direct "),
          ]),
          _c("span", { staticClass: "wkb-inspector-connected-legend-item" }, [
            _c("span", {
              staticClass:
                "wkb-inspector-connected-swatch wkb-inspector-connected-swatch--indirect",
            }),
            _vm._v(" Indirect "),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }